import { Link } from 'react-router-dom'

import { api } from '../api/client'
import { usePolling } from '../hooks/useAsync'
import { t } from '../i18n/lingua'

/**
 * L'indicatore «Honeypot attivo» nella barra in alto: giallo, con un'ape
 * stilizzata. Compare **solo quando ci sono esche accese** — un badge acceso
 * su zero esche direbbe una protezione che non c'è. Il led lampeggia quando
 * ci sono hit nuovi (qualcuno è cascato nella trappola).
 */
export default function HoneypotBadge() {
  const { data } = usePolling(() => api.honeypot(), 60000)
  const attivo = Boolean((data?.summary.decoys_active ?? 0) > 0 && (data?.summary.agents_active ?? 0) > 0)
  if (!attivo) return null

  const nuovi = data?.summary.new ?? 0

  return (
    <Link
      to="/honeypot"
      className={`hp-topbar${nuovi > 0 ? ' hp-topbar--hit' : ''}`}
      title={
        nuovi > 0
          ? t('{n} nuovi hit sulle esche', { n: nuovi })
          : t('Honeypot in ascolto')
      }
    >
      <Ape />
      <span className="hp-topbar__testo">{t('Honeypot attivo')}</span>
      {nuovi > 0 && <span className="hp-topbar__conta">{nuovi}</span>}
    </Link>
  )
}

/**
 * Un'ape stilizzata: corpo ovale a strisce, ali, pungiglione. Geometrica —
 * un'icona, non un disegno. Il giallo lo mette la classe attorno; qui il
 * disegno usa `currentColor` per il contorno e un giallo pieno per il corpo.
 */
function Ape() {
  return (
    <svg
      className="hp-topbar__ape"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      aria-hidden="true"
    >
      {/* Ali. */}
      <ellipse cx="8.5" cy="7.5" rx="3.2" ry="2.2" transform="rotate(-25 8.5 7.5)"
               fill="#fde68a" stroke="currentColor" strokeWidth="1" />
      <ellipse cx="15.5" cy="7.5" rx="3.2" ry="2.2" transform="rotate(25 15.5 7.5)"
               fill="#fde68a" stroke="currentColor" strokeWidth="1" />
      {/* Corpo. */}
      <ellipse cx="12" cy="13.5" rx="4.6" ry="6" fill="#f5c518" stroke="currentColor" strokeWidth="1.2" />
      {/* Strisce. */}
      <path d="M8 12 h8 M7.8 15 h8.4 M9 18 h6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      {/* Pungiglione. */}
      <path d="M12 19.5 l0 2.3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      {/* Antenne. */}
      <path d="M10.5 7.8 q-1.2 -2.2 -2.6 -2.8 M13.5 7.8 q1.2 -2.2 2.6 -2.8"
            stroke="currentColor" strokeWidth="1" fill="none" strokeLinecap="round" />
    </svg>
  )
}
